import Lightbox from './bs5-lightbox';

const options = {
	keyboard: true
};

document.querySelectorAll('[data-toggle="lightbox"]').forEach((el) => el.addEventListener('click', (e) => {
	e.preventDefault();
	const lightbox = new Lightbox(el, options);
	lightbox.show();
}));
//
// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

const swiper = new Swiper('.logos', {
    // Optional parameters
    //direction: 'vertical',
	modules: [Autoplay, Navigation, Pagination],
    loop: true,
	slidesPerView: 1,
	breakpoints: {
		1200:{
			slidesPerView: 6,
			spaceBetween: 24
		},
		992:{
			slidesPerView: 4,
			spaceBetween: 15
		},
		782:{
			slidesPerView: 3,
		},
		576:{
			slidesPerView: 2,
		}
	},
	autoHeight: true, // Make slides equal height
	autoplay: {
		delay: 10000,
	},
	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	pagination: {
        el: '.swiper-pagination',
        clickable: true, // Enable navigation through pagination bullets
    },
});


// Testimonials Carousel
const swiperTestimonials = new Swiper('.wp-block-lazyblock-testimonial-carousel .testimonial-slider', {
    // Optional parameters
	modules: [Autoplay, Navigation, Pagination],
	slidesPerView: 1,
	autoHeight: true, // Make slides equal height
	autoplay: {
		delay: 10000,
		//disableOnInteraction: false, // Allow manual interaction without stopping autoplay
	},
	// Navigation arrows
	//navigation: {
	//	nextEl: '.swiper-button-next',
	//	prevEl: '.swiper-button-prev',
	//},
	//allowTouchMove: false, // This disables touch swipe
	//simulateTouch: false,  // Prevent mouse drag behavior (simulated touch)
	pagination: {
        el: '.swiper-pagination',
        clickable: true, // Enable navigation through pagination bullets
    }
});



//
// Back to Top Button
// Get the button
var mybutton = document.getElementById("btn-back-to-top");
// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
    scrollFunction();
};
//
function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
    }
    else {
        mybutton.style.display = "none";
    }
}
// When the user clicks on the button, scroll to the top of the document
mybutton.addEventListener("click", backToTop);
//
function backToTop() {
    jQuery("html, body").animate({ scrollTop: 0 }, "slow");
}

//
// Smooth Scrolling for Anchor Links
//
// jQuery(document).ready(function($) {
//     $('a[href^="#anchor-"]').on('click', function(e) {
//         e.preventDefault(); // Prevent default behavior

//         var target = $(this).attr('href'); // Get the target link
//         var $targetElement = $(target); // The target element itself

//         if ($targetElement.length) { // Only run if the target exists
//             var headerHeight = $('.sticky-lg-top').outerHeight() || 0; // Calculate header height or default to 0
//             var targetPosition = $targetElement.offset().top - headerHeight; // Calculate final scroll position

//             // Smooth scrolling
//             $('html, body').animate({
//                 scrollTop: targetPosition
//             }, 500); // You can increase the speed to make the scroll smoother
//         }
//     });
// });


